(function (){
    'use strict';
    angular.module('app').controller('AffiliateAccountsController',AffiliateAccountsController);
    AffiliateAccountsController.$inject=[
        'AffiliateService',
        '$location',
        '$routeParams',
        'toastr',
        '$scope',
        '$rootScope'
    ];

    function AffiliateAccountsController (AffiliateService,$location,$routeParams,toastr,$scope,$rootScope){
        const vm = this;
        vm.role = $rootScope.GlobalProfile.permissionGroup.roles.find(per=> per.code == 'ROLE_COMPANY_ADMIN' || per.code == 'ROLE_ADMIN' );
        vm.paramId = $routeParams.id;
        vm.marketingCompany={
            bankDetails:{},
            commission:{}
        }
        vm.companDisabled = true;

        init();
        
        function init(){
            getAccountDetails();
        }

        vm.onSubmit = function(form){
            if(form.$valid){
                save();
                return;
            }
            for(let field of $scope.form.$error.required){
                if(field.$name){
                    $scope.form[field.$name].$touched = true
                }
            }
            
        }
        vm.goBack = goback;

        function getAccountDetails(){
            AffiliateService.getCompanyDetails(
                res=>{
                    vm.marketingCompany.name = res.name
                },
                err=>{
                    console.log(err)
                },$routeParams.id
            )
        }
       

        function goback(){
            $location.path('/affiliates-sales/accounts/'+vm.paramId);
        }

        function save(){
            vm.marketingCompany.companyMarketingId = $routeParams.id
            vm.marketingCompany.locationId = vm.location.id
            AffiliateService.createUserMarketing(
                res=>{
                    goback();
                    toastr.error(err.message,err.code)
                },
                err=>{
                    toastr.error(err.message,err.code)
                },vm.marketingCompany
            );
        }
    }

})()



// WEBPACK FOOTER //
// ./js/controllers/affiliate-sale/accounts/AffiliateAccountsController.js